import React from 'react';
import { ITaxInvoice } from '@/interfaces/report';
import { formatThaiDate, formatNumber } from '@/utils/dataUtils';
interface IProps {
  items: ITaxInvoice[];
  currentPage: number;
  limit: number;
  lastPage: boolean;
  totalAmount: number;
  totalVatAmount: number;
}

const TemplateTaxInvoiceItem = ({
  items,
  currentPage,
  limit,
  lastPage,
  totalAmount,
  totalVatAmount,
}: IProps) => {
  return (
    <div className="flex w-full text-xs mt-2">
      <table
        border={1}
        cellSpacing={0}
        cellPadding={2}
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: 10,
        }}
      >
        <tr>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            width={5}
            rowSpan={2}
          >
            <strong>ลำดับ</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            width={80}
            colSpan={2}
          >
            <strong>ใบกำกับภาษี</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            rowSpan={2}
          >
            <strong>ชื่อผู้ซื้อสินค้า/ผู้รับบริการ</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            rowSpan={2}
            width={90}
          >
            <strong>
              เลขประจำตัวผู้เสียภาษีอากรของผู้ซื้อสินค้า/ผู้รับบริการ
            </strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            colSpan={2}
          >
            <strong>สถานประกอบการ</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            width={80}
            rowSpan={2}
          >
            <strong>มูลค่าสินค้าหรือบริการ</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            width={70}
            rowSpan={2}
          >
            <strong>จำนวนเงินภาษีมูลค่าเพิ่ม</strong>
          </td>
        </tr>
        <tr>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            width={70}
          >
            <strong>วัน เดือน ปี</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            width={80}
          >
            <strong>เล่มที่/เลขที่</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            width={40}
          >
            <strong>สำนักงานใหญ่</strong>
          </td>
          <td
            style={{
              border: '0.5px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            width={40}
          >
            <strong>สาขา</strong>
          </td>
        </tr>
        {items?.map((i, idx) => {
          return (
            <tr key={i.id}>
              <td
                style={{
                  textAlign: 'center',
                  border: '0.5px solid black',
                }}
              >
                {(0 + currentPage - 1) * limit + idx + 1}
              </td>
              <td
                style={{
                  textAlign: 'center',
                  border: '0.5px solid black',
                }}
              >
                {formatThaiDate(i.orderDate ?? undefined)}
              </td>
              <td style={{ border: '0.5px solid black', textAlign: 'center' }}>
                {i.orderNo}
              </td>
              <td style={{ border: '0.5px solid black' }}>{i.customerName}</td>
              <td style={{ border: '0.5px solid black', textAlign: 'center' }}>
                {i.customerTaxId}
              </td>
              <td style={{ border: '0.5px solid black', textAlign: 'center' }}>
                {i.branchName === '00000' ? i.branchName : ''}
              </td>
              <td style={{ border: '0.5px solid black', textAlign: 'center' }}>
                {i.branchName !== '00000' ? i.branchName : ''}
              </td>
              <td
                style={{
                  textAlign: 'right',
                  border: '0.5px solid black',
                }}
              >
                {formatNumber(i.totalAmount, 2)}
              </td>
              <td
                style={{
                  textAlign: 'right',
                  border: '0.5px solid black',
                }}
              >
                {(i.vatAmount && formatNumber(i.vatAmount, 2)) || '-'}
              </td>
            </tr>
          );
        })}
        {lastPage && (
          <tr
            style={{
              border: '1px solid black',
              textAlign: 'right',
              verticalAlign: 'middle',
              fontWeight: 'bold',
            }}
          >
            <td colSpan={6}></td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
              }}
            >
              รวม
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'right',
              }}
            >
              {formatNumber(totalAmount, 2)}
            </td>
            <td
              style={{
                borderTop: '1px solid black',
                borderBottom: '1px solid black',
                textAlign: 'right',
                verticalAlign: 'middle',
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              {(totalVatAmount && formatNumber(totalVatAmount, 2)) || '-'}
            </td>
          </tr>
        )}
      </table>
    </div>
  );
};

export default TemplateTaxInvoiceItem;
